!<template>
  <div class="router-header flex flex-wrap items-center">
    <div class="content-area__heading">
      <vs-button
        radius
        @click.stop="back()"
        class="float-left mr-2"
        type="border"
        icon-pack="feather"
        icon="icon-arrow-left"
      ></vs-button>

      <span class="font">{{ users.name | upper }}</span>
    </div>
    <!-- <div class="ml-auto md:block">
            <vs-button color="danger" icon-pack="feather">Deactivate</vs-button>
        </div> -->
    <vx-card class="mt-4">
      <vs-tabs vs-alignment="fixed">
        <vs-tab :label="$t('labels.profile_details')">
          <vs-row vs-w="12">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-avatar
                class="mx-auto"
                size="100px"
                :src="users.profile_pic"
              />
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <h2>{{ users.name | upper }}</h2>
              <p>{{ users.email }}</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
          <vs-divider></vs-divider>
          <vs-row vs-w="12" class="mb-3" v-if="users.facebook_profile_id">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <p>
                <b>{{ $t("labels.facebook_id") }} :</b>
              </p>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <p>{{ users.facebook_profile_id }}</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="mb-3" v-if="users.google_profile_id">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <p>
                <b>{{ $t("labels.google_id") }} :</b>
              </p>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <p>{{ users.google_profile_id }}</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="mb-3" v-if="users.apple_profile_id">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <p>
                <b>{{ $t("labels.apple_id") }} :</b>
              </p>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <p>{{ users.apple_profile_id }}</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="mb-3">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <p>
                <b>{{ $t("labels.city") }} :</b>
              </p>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <p>
                {{
                  users.city + ", " + (users.zipcode ? users.zipcode : "null")
                }}
              </p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="mb-3">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <p>
                <b>{{ $t("labels.interest") }} :</b>
              </p>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <span>{{ users.interests | interest }}</span>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
        </vs-tab>
        <vs-tab :label="$t('labels.booking')">
          <vs-table max-items="10" :data="bookings">
            <template slot="thead">
              <vs-th>{{ $t("labels.class_title") }}</vs-th>
              <vs-th>{{ $t("labels.category") }}</vs-th>
              <vs-th>{{ $t("labels.mode_of_class") }}</vs-th>
              <vs-th>{{ $t("labels.hosted_by") }}</vs-th>
              <vs-th>{{ $t("labels.s_d_t") }}</vs-th>
              <!-- <vs-th>{{ $t("labels.payment_method") }}</vs-th> -->
              <vs-th>{{ $t("labels.Payment_status") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].title">
                  {{ data[indextr].title }}
                </vs-td>

                <vs-td :data="data[indextr].code">
                  {{ data[indextr].code }}
                </vs-td>

                <vs-td :data="data[indextr].type">
                  <p v-if="data[indextr].type == 'OF'">
                    {{ $t("labels.offline") }}
                  </p>
                  <p v-if="data[indextr].type == 'ON'">
                    {{ $t("labels.online") }}
                  </p>
                </vs-td>

                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>

                <vs-td :data="data[indextr].date">
                  {{ data[indextr].date + " " + data[indextr].starting_time }}
                </vs-td>
                <vs-td :data="data[indextr].date">
                  {{ data[indextr].payment_status | upper}}
                  </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    users: [],
    bookings: [],
    apple: 0,
    facebook: 0,
    google: 0,
    page:null,
  }),
  methods: {
    getStudents() {
      axios
        .get("admin/studentById/" + this.$route.params.id)
        .then((response) => {
          //   let data = response.data.data;
          this.users = response.data.data;
          // console.log(this.users);
        })
        .catch((err) => console.log(err.response));
    },
    getBookings() {
      axios
        .get("class/studentWiseBooking/" + this.$route.params.id)
        .then((response) => {
          // let data = response.data.data;
          this.bookings = response.data.data;
          console.log(this.bookings);
        })
        .catch((err) => console.log(err.response));
    },
    back() {
       if(this.page){
         this.$router.push({ name: "Students", query: { page: this.page } });
        // this.$router.push({name: "Students",params:{page:this.page}});
      }
      else{ 
       history.back();
      }
      // history.back();
    },
  },
  mounted() {
    this.getStudents();
    this.getBookings();
     if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }
  },
};
</script>

<style lang="scss" scoped>
</style>